import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = () => {
  const { isLoggedIn, saveRedirectUrl } = useAuth();

  useEffect(() => {
    if (!isLoggedIn) {
      saveRedirectUrl();
    }
  }, [isLoggedIn, saveRedirectUrl]);

  if (!isLoggedIn) {
    return <Navigate to="/login" />;
  }

  return <Outlet />;
};
